import { useEffect } from "react";
import { Link, Typography } from "@powerdiary/components-library/lib";
import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";
import { warmRecaptcha } from "utils/recaptcha";

/**
 * The disclosure Google's terms require wherever reCAPTCHA runs. It stands in for the floating
 * badge, which index.scss hides, and it renders nothing for practices without bot protection.
 */
export default function RecaptchaNotice() {
    const { clientPortalConfig } = useClientPortalConfigContext();
    const siteKey = clientPortalConfig?.reCaptchaSiteKey;

    useEffect(() => {
        if (siteKey) {
            warmRecaptcha(siteKey);
        }
    }, [siteKey]);

    if (!siteKey) {
        return null;
    }

    return (
        <Typography variant="paragraphSmallRegular" color="textSecondary" textAlign="center">
            This site is protected by reCAPTCHA and the Google{" "}
            <Link
                variant="paragraphSmallRegular"
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener"
            >
                Privacy Policy
            </Link>{" "}
            and{" "}
            <Link
                variant="paragraphSmallRegular"
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener"
            >
                Terms of Service
            </Link>{" "}
            apply.
        </Typography>
    );
}
